import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { rm } from "@/lib/format";
import { useDashboardCtx } from "@/context/DashboardContext";
import { Input } from "@/components/ui/input";
import { Loader2, Search, MessageSquare, Globe } from "lucide-react";

const SCORE = { HOT: "bg-destructive/15 text-destructive", WARM: "bg-primary/15 text-primary", COLD: "bg-muted text-muted-foreground" };
const STAGE = { NEW: "New", CONTACTED: "Contacted", QUALIFIED: "Qualified", PROPOSAL: "Proposal", FOLLOWUP: "Follow-up", SALE: "Sale", LOST: "Lost" };

export default function LeadCentre() {
  const { customerId } = useDashboardCtx();
  const [leads, setLeads] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/leads", { params: customerId ? { customer_id: customerId } : {} })
      .then((r) => setLeads(r.data)).catch(() => {});
  }, [customerId]);

  if (!leads) return <div className="flex justify-center py-20"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;
  const filtered = leads.filter((l) => l.name.toLowerCase().includes(q.toLowerCase()) || l.campaign.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="space-y-4 animate-float-up" data-testid="leads-panel">
      <div className="relative max-w-sm">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input data-testid="leads-search" className="pl-9" placeholder="Search leads or campaigns…" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>
      <div className="bg-card border border-border rounded-2xl overflow-hidden">
        <div className="overflow-x-auto scrollbar-thin">
          <table className="w-full text-sm">
            <thead className="bg-secondary/40 text-muted-foreground text-xs uppercase">
              <tr>
                {["Lead", "Source", "Campaign / Product", "Assigned", "Score", "Stage", "Revenue"].map((h) => <th key={h} className="text-left font-medium px-4 py-3 whitespace-nowrap">{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {filtered.map((l) => (
                <tr key={l.id} data-testid={`lead-row-${l.id}`} className="border-t border-border hover:bg-secondary/30 transition-colors">
                  <td className="px-4 py-3"><p className="font-medium">{l.name}</p><p className="text-xs text-muted-foreground">{l.phone}</p></td>
                  <td className="px-4 py-3"><span className="inline-flex items-center gap-1 text-xs text-muted-foreground">{l.source === "WhatsApp" ? <MessageSquare className="w-3.5 h-3.5 text-accent" /> : <Globe className="w-3.5 h-3.5 text-chart-3" />}{l.source}</span><p className="text-[11px] text-muted-foreground mt-0.5">{l.platform}</p></td>
                  <td className="px-4 py-3"><p className="text-xs">{l.campaign}</p><p className="text-[11px] text-muted-foreground">{l.product}</p></td>
                  <td className="px-4 py-3 text-muted-foreground">{l.assigned}</td>
                  <td className="px-4 py-3"><span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${SCORE[l.score]}`}>{l.score}</span></td>
                  <td className="px-4 py-3 text-xs">{STAGE[l.stage] || l.stage}</td>
                  <td className="px-4 py-3 font-mono">{l.revenue ? rm(l.revenue) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
